import { DataBean } from "../DataBean";

export class TaxHoldValueConst extends DataBean {



    public async getTaxHoldValueConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxHoldValueConstants_Number", [id]);
    }
    
}